import { render, staticRenderFns } from "./tipsBox.vue?vue&type=template&id=6a11060e&scoped=true&"
import script from "./tipsBox.vue?vue&type=script&lang=js&"
export * from "./tipsBox.vue?vue&type=script&lang=js&"
import style0 from "./tipsBox.vue?vue&type=style&index=0&id=6a11060e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a11060e",
  null
  
)

export default component.exports